/* GG_FULLSCREEN_VIDEO_42 */
(() => {
  if (window.ggFullscreenVideos42) return;
  window.ggFullscreenVideos42 = true;
  const states = new WeakMap();
  let active = null;
  function message(state, text) {
    if (!state.status) return;
    state.status.textContent = text;
    state.status.hidden = !text;
  }
  function close(state, leaveFullscreen = true, returnFocus = true) {
    if (active !== state) return;
    active = null;
    state.video.pause();
    if (leaveFullscreen) {
      if (document.fullscreenElement === state.video && document.exitFullscreen) {
        try { document.exitFullscreen()?.catch(() => {}); } catch (_) {}
      } else if (state.video.webkitDisplayingFullscreen && state.video.webkitExitFullscreen) {
        try { state.video.webkitExitFullscreen(); } catch (_) {}
      }
    }
    state.nativeMode = null;
    if (typeof state.dialog.close === 'function' && state.dialog.open) state.dialog.close();
    else state.dialog.removeAttribute('open');
    document.body.style.overflow = state.bodyOverflow;
    if (state.card.isConnected) state.card.appendChild(state.dialog);
    else state.dialog.remove();
    if (returnFocus && state.link.isConnected) state.link.focus({ preventScroll: true });
  }
  function fullscreen(state) {
    const video = state.video;
    // This runs directly in the click handler, before awaiting playback/network.
    if (typeof video.webkitEnterFullscreen === 'function' && (video.webkitSupportsFullscreen || typeof video.requestFullscreen !== 'function')) {
      try { video.webkitEnterFullscreen(); return; } catch (_) {}
    }
    if (typeof video.requestFullscreen === 'function' && document.fullscreenEnabled !== false) {
      try {
        video.requestFullscreen()?.then(() => {
          if (active !== state && document.fullscreenElement === video) document.exitFullscreen()?.catch(() => {});
        }).catch(() => {
          // The viewport-sized dialog is already open if native fullscreen is denied.
        });
      } catch (_) {}
    }
  }
  function open(state) {
    if (active === state) return;
    if (active) close(active, true, false);
    active = state;
    state.bodyOverflow = document.body.style.overflow;
    state.nativeMode = null;
    message(state, '');
    document.body.appendChild(state.dialog);
    state.nativeDialog = false;
    if (typeof state.dialog.showModal === 'function') {
      try { state.dialog.showModal(); state.nativeDialog = true; } catch (_) { state.dialog.setAttribute('open', ''); }
    } else state.dialog.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    state.closeButton.focus({ preventScroll: true });
    if (state.video.ended) state.video.currentTime = 0;
    try {
      state.video.play()?.catch(() => {
        if (active === state) message(state, 'Naciśnij przycisk odtwarzania na filmie, aby rozpocząć.');
      });
    } catch (_) { message(state, 'Naciśnij przycisk odtwarzania na filmie, aby rozpocząć.'); }
    fullscreen(state);
  }
  function init(root = document) {
    root.querySelectorAll('[data-gg42-video]').forEach(card => {
      if (states.has(card)) return;
      const link = card.querySelector('.gg42-cover');
      const dialog = card.querySelector('.gg42-viewer');
      const video = dialog?.querySelector('video');
      const closeButton = dialog?.querySelector('.gg42-close');
      if (!link || !dialog || !video || !closeButton) return;
      const state = { card, link, dialog, video, closeButton, status: dialog.querySelector('.gg42-status') };
      states.set(card, state);
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(state);
      });
      closeButton.addEventListener('click', () => close(state));
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(state); });
      dialog.addEventListener('close', () => { if (active === state && !dialog.open) close(state); });
      video.addEventListener('webkitbeginfullscreen', () => { if (active === state) state.nativeMode = 'webkit'; });
      video.addEventListener('webkitendfullscreen', () => { if (active === state) close(state, false); });
      video.addEventListener('playing', () => message(state, ''));
      video.addEventListener('error', () => { if (active === state) message(state, 'Nie udało się wczytać filmu. Zamknij odtwarzacz i spróbuj ponownie.'); });
    });
  }
  document.addEventListener('fullscreenchange', () => {
    if (!active) return;
    if (document.fullscreenElement === active.video) active.nativeMode = 'standard';
    else if (active.nativeMode === 'standard') close(active, false);
  });
  document.addEventListener('keydown', event => {
    if (!active || document.fullscreenElement === active.video || active.video.webkitDisplayingFullscreen) return;
    if (event.key === 'Escape') { event.preventDefault(); close(active); }
    if (event.key === 'Tab' && !active.nativeDialog) {
      // Also keeps focus inside the viewport fallback when native dialog is unavailable.
      const focused = document.activeElement;
      if (event.shiftKey && (focused === active.closeButton || focused === active.dialog)) {
        event.preventDefault(); active.video.focus();
      } else if (!event.shiftKey && focused === active.video) {
        event.preventDefault(); active.closeButton.focus();
      }
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active.card)) close(active, true, false);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
